module.exports = __webpack_public_path__ + "static/media/mona.479b0aa1.jpeg";